export default __webpack_public_path__ + "static/media/roby1.3ed6519f.jpg";